<div class="bulk-upload-arrangement">
  <p class="bulk-upload-arrangement__summary">
    {{
      "Uploading {{pagesCount}}
    pages across {{ filesCount }} files" | translate: { pagesCount: selectedPagesCount, filesCount:
    selectedFilesCount } }}
  </p>
  <p class="bulk-upload-arrangement__header">
    {{ 'Lastly, how should we arrange your files?' | translate }}
  </p>
  <p class="bulk-upload-arrangement__body">
    {{ 'You can rearrange pages after uploading.' | translate }}
  </p>

  <div class="bulk-upload-arrangement__list">
    <button
      *ngFor="let option of options"
      type="button"
      class="bulk-upload-arrangement__card"
      [class.bulk-upload-arrangement__card--selected]="selectedArrangement === option.id"
      (click)="selectOption(option.id)"
    >
      <div class="bulk-upload-arrangement__card-content">
        <p class="bulk-upload-arrangement__card-title">{{ option.title }}</p>
        <p class="bulk-upload-arrangement__card-description">
          {{ option.description }}
        </p>
      </div>
      <div class="bulk-upload-arrangement__preview">
        <ng-container [ngSwitch]="option.id">
          <div *ngSwitchCase="'columns'" class="bulk-upload-arrangement__preview-columns">
            <svg-icon
              class="bulk-upload-arrangement__preview-icon"
              [icon]="'columns_stacking'"
              [width]="80"
              [height]="125"
            >
            </svg-icon>
          </div>
          <div *ngSwitchDefault class="bulk-upload-arrangement__preview-stacked">
            <svg-icon
              class="bulk-upload-arrangement__preview-icon"
              [icon]="'vertical_stacking'"
              [width]="80"
              [height]="125"
            >
            </svg-icon>
          </div>
        </ng-container>
      </div>
    </button>
  </div>
</div>
